import axios from "axios";
import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface ServerInfo {
    applicationVersion: string;
    environment: string;
    serverName: string;
    pamsDatabaseVersion: string;
    pbdpDatabaseVersion: string;
    dataVersion: string;
}

export const getServerInfoAsync = async (
    token: string
): Promise<ServerInfo> => {
    const baseUrl = getApiBaseUrl();
    const response = await axios.get(
        `${baseUrl}/api/Admin/ServerInfo`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    return response.data;
};